import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Button, Checkbox, message, Spin, Tabs as AantdTabs } from 'antd';
import Item from '../Tab/Item';
import {
  joyspacePermissionType,
  PermissionEnum,
  SharesMembersType,
  FileType,
} from '../types';
import { JoyspacePermissionType } from '../config/permissions.config';
import { LoadingOutlined } from '@ant-design/icons';
import { throttle } from '../utils';
import styles from './index.module.less';
import Loading from '../Loading';
import TabListBottom from './TablistBottom';
const { TabPane } = AantdTabs;
const AntdIcon = (
  <LoadingOutlined style={{ fontSize: 18, marginRight: 8 }} spin />
);

interface IProps {
  list: any[];
  config?: any[];
  // type: any
  defaultActiveKey?: any;
  // pagination?: Boolean
  permissions?: PermissionEnum[]; // 权限
  myPermissionType?: JoyspacePermissionType | any; // 你当前的权限
  loading?: Boolean;
  isLoadMore?: Boolean;
  noDataUrl?: string;
  noDataText?: string;
  onChangeTab?: (val: any) => void;
  handleMenuClick?: (val: any, id: string) => void;
  onButtom?: () => void;
  rightRenderDOM?: (item: any) => void;
  events?: any;
  type?: FileType; // 判断是文件还是文件夹
  id?: string; // 文档/文件夹id，webapp中需要控制更新数据
  hasTabs?: boolean; // 是否显示tab栏
  hasListHeader?: boolean; // 是否显示列表头部（全选，添加协作者
  customItemStyle?: any; // 自定义item样式
  customListStyle?: any; // 自定义list样式
  hasCheckbox?: boolean; // 头像旁边是否有多选框
  isKnowledge?: boolean; // 是否为知识库
  isWeb?: boolean;
}

function Tabs(props: IProps) {
  const {
    config = [],
    defaultActiveKey,
    // type,
    list,
    onChangeTab,
    // pagination,
    // permissionType,
    loading,
    isLoadMore,
    handleMenuClick,
    onButtom,
    noDataUrl,
    noDataText,
    rightRenderDOM,
    events,
    permissions,
    myPermissionType,
    type = FileType.Page,
    id,
    hasTabs = true,
    hasListHeader = true,
    customItemStyle = {},
    customListStyle = {},
    hasCheckbox = true,
    isKnowledge = false,
    isWeb = false,
  } = props;
  const scrollViewRef: any = useRef();
  const [checkboxList, setCheckboxList] = useState<string[]>([]);
  const [isCheckedAll, setIsCheckedAll] = useState<boolean>(false);
  const [filteredList, setFilteredList] = useState([]); // 满足条件的用户列表
  const currentTab = useRef(SharesMembersType.ALL);
  const bottomTab = useRef(SharesMembersType.ALL);

  const handleOnScroll = throttle(() => {
    // 避免先触发切换tab加载数据，后触底加载数据，出现串数据
    if (bottomTab.current !== currentTab.current) {
      return;
    }
    onButtom?.();
  }, 400);

  const onScroll = () => {
    // if (!pagination) {
    //   return
    // }
    const cu: any = scrollViewRef.current;
    const scrollTop = cu.scrollTop;
    const cHight = cu.clientHeight;
    const sHight = cu.scrollHeight;
    if (cu && isLoadMore && !loading && scrollTop + cHight >= sHight - 10) {
      bottomTab.current = currentTab.current;
      handleOnScroll();
    }
  };

  useEffect(() => {
    const _membersList = list.filter((item: any) => {
      return (
        !(
          // 排除所有者
          (
            item.permissionType === 0 &&
            item.memberType === SharesMembersType.CONTACT
          )
        ) && !item.inherited // 排除继承的人
      );
    });
    setFilteredList(_membersList as any);
    setIsCheckedAll(
      _membersList.length !== 0 && _membersList.length === checkboxList.length
    );
  }, [list, checkboxList]);

  useEffect(() => {
    const canSelect = checkboxList.length === 0;
    events?.emit('addmembers:setPermissionCanSelect', canSelect);
  }, [checkboxList]);

  const handleCheckAllbox = useCallback(
    (isChecked: boolean) => {
      const _checkBtns = isChecked
        ? filteredList.map((item: any) => item.id)
        : [];
      const _membersList = list.map((item: any) => {
        if (
          !(
            // 排除所有者
            (
              item.permissionType === 0 &&
              item.memberType === SharesMembersType.CONTACT
            )
          ) &&
          !item.inherited // 排除继承的人
        ) {
          item.isChecked = isChecked;
        }
        return item;
      });
      events.emit('addmembers:setMembersList', _membersList);
      setCheckboxList(_checkBtns);
    },
    [list, filteredList, setCheckboxList, events]
  );

  const handleCheckbox = useCallback(
    (params: any) => {
      const { selectedId = '', isChecked = false } = params;

      const _membersList = [...list];
      const memberIndex = _membersList.findIndex(
        (item: any) => item.id === selectedId
      );
      if (memberIndex !== -1) {
        _membersList[memberIndex].isChecked = isChecked;
      }

      const _checkBtns = [...checkboxList];
      const selectedIndex = _checkBtns.indexOf(selectedId);
      if (selectedIndex !== -1) {
        _checkBtns.splice(selectedIndex, 1);
      } else {
        _checkBtns.push(selectedId);
      }
      events.emit('addmembers:setMembersList', _membersList);
      setCheckboxList(_checkBtns);
    },
    [checkboxList, list, events]
  );

  const getNode = useMemo(() => {
    const owners = list.filter(
      (item: any) =>
        item.permissionType === JoyspacePermissionType.ReadAll &&
        item.memberType === SharesMembersType.CONTACT
    );
    return list.map((item: any, index: number) => {
      if (checkboxList.length !== 0) {
        item.isChecked = checkboxList.includes(item.id);
      }
      return (
        <Item
          key={item.id}
          {...item}
          owners={owners}
          // permission={permissionType}
          // fileType={type}
          handleMenuClick={handleMenuClick}
          rightRenderDOM={() => rightRenderDOM?.(item)}
          handleCheckbox={handleCheckbox}
          myPermissionType={myPermissionType}
          customItemStyle={customItemStyle}
          hasCheckbox={hasCheckbox}
          showInheritText={!isKnowledge}
        />
      );
    });
  }, [
    list,
    handleCheckbox,
    checkboxList,
    handleMenuClick,
    rightRenderDOM,
    isKnowledge,
  ]);

  const getListBottom = useCallback(() => {
    console.log('getListBottomtet11', id, props.id);
    return (
      <TabListBottom
        membersList={list}
        events={events}
        setCheckboxList={setCheckboxList}
        checkboxList={checkboxList}
        type={type}
        id={id}
        isWeb={isWeb}
      />
    );
  }, [list, setCheckboxList, checkboxList, events, id, isWeb]);

  const getListHeader = useMemo(() => {
    return (
      <div className={styles['joyspace-tab-list-header']}>
        {myPermissionType < joyspacePermissionType.ReadOnly &&
          list.length !== 0 && (
            <div className={styles['list-header-left']}>
              <Checkbox
                style={{ marginRight: '16px' }}
                onChange={e => handleCheckAllbox(e.target.checked)}
                checked={isCheckedAll}
                indeterminate={
                  checkboxList.length > 0 &&
                  checkboxList.length < filteredList.length
                }
                disabled={filteredList.length === 0}
              />
              全选
            </div>
          )}
        <div className={styles['list-header-right']}>
          <Button
            type="text"
            className={styles['add-members-button']}
            disabled={
              !permissions?.includes(PermissionEnum.SHARE_CREATE) ||
              checkboxList.length !== 0
            }
            onClick={throttle(() => {
              if ((myPermissionType as any) === -99) {
                message.error('您不是协作者，无法完成操作');
                return;
              }
              events.emit('addmembers:setModalAddUserVisible', true);
            }, 400)}
          >
            +添加协作者
          </Button>
        </div>
      </div>
    );
  }, [
    isCheckedAll,
    checkboxList,
    filteredList,
    permissions,
    myPermissionType,
    events,
  ]);

  const handleChangeTab = useCallback(
    value => {
      if (checkboxList.length !== 0 && currentTab.current === Number(value)) {
        return;
      }
      currentTab.current = Number(value);
      onChangeTab?.(value);
    },
    [checkboxList, currentTab, onChangeTab]
  );

  return (
    <div>
      {hasTabs && (
        <AantdTabs
          defaultActiveKey={defaultActiveKey}
          onChange={handleChangeTab}
        >
          {config.map(item => {
            return (
              <TabPane
                tab={`${item.text}`}
                key={item.type}
                disabled={checkboxList.length !== 0 && currentTab !== item.type}
              />
            );
          })}
        </AantdTabs>
      )}
      {hasListHeader && getListHeader}
      <div
        className={`${styles['joyspace-tab-list-box']} ${customListStyle[
          'custom-list-box'
        ] || ''}`}
        ref={scrollViewRef}
        onScroll={onScroll}
      >
        {!loading && list.length > 0 && getNode}
        {loading && (
          <div className={styles['joyspace-tab-list--not-data']}>
            <div className={styles['list-tab-loading']}>
              <Loading />
            </div>
          </div>
        )}
        {!loading && isLoadMore && list.length > 0 && (
          <div className={styles['joyspace-tab-list--not-data']}>
            <div className={styles['joyspace-tab-more']}>
              {/* <LoadMoreLoading /> */}
              <Spin indicator={AntdIcon} />
              <span style={{ whiteSpace: 'nowrap' }}>加载更多</span>
            </div>
          </div>
        )}
        {!loading && !list.length && (
          <div className={styles['joyspace-tab-list--not-data']}>
            <div className={styles['joyspace-tab--doc-nodata']}>
              {noDataUrl && <img src={noDataUrl} />}
              <p>{noDataText || '暂无数据'}</p>
            </div>
          </div>
        )}
      </div>
      {checkboxList?.length !== 0 && getListBottom?.()}
    </div>
  );
}

export default Tabs;
